import React from "react";
import './Badge.css';

export const  Badge = ( props ) => {
    let {
         bgcolor, 
         children, 
         attributes,
         cancel 
      } = props;

    return (
        <>
        <span {...attributes} 
            className="badge  " 
            // ref={innerRef} 
            style={bgcolor && { backgroundColor: "#"+ bgcolor }}
        >{children}
        {cancel&&
            <a {...attributes} 
            className="clean-tag" 
            href="#1"
            onClick={() => cancel() }
            // ref={innerRef} 
            style={ bgcolor && { backgroundColor: "#"+ bgcolor }}
            >X</a>
         }
        </span>
        
        </>
    );
  }





// const classes = mapToCssModules(classNames(
//     className,
//     'badge',
//     'badge-' + color,
//     pill ? 'badge-pill' : false
//   ), cssModule);

//   if (attributes.href && Tag === 'span') {
//     Tag = 'a';
//   }

//   return (
//     <Tag {...attributes} className={classes} ref={innerRef} />
//   );